module.exports = __webpack_public_path__ + "static/media/KinoLogo.b3806393.svg";